import { AbstractAnalyticsTracker } from '@inter-ikea-kompis/analytics';
import { IpexMomentEnum } from '@insights/insights-data-provider';
const moduleId = 'zip_in';
/**
 * @event zip_code_action When an action is performed in the zip in sheet.
 */
export default class ZipInTracker extends AbstractAnalyticsTracker {
    constructor(options) {
        super({ moduleId, ...options });
    }
    sendZipCodeAction(action) {
        const payload = {
            common: { component: moduleId },
            data: {
                action
            }
        };
        this.getReporter().report({
            event: 'zip_code_action',
            ipexMoment: IpexMomentEnum.showMe,
            payload
        });
    }
}
//# sourceMappingURL=ZipInTracker.js.map